export enum PdaPlaceholders {
    pda_infos = "PDA_ACCEPTANCE_INFOS",
    pda_token = "x-justice-pda-auth-token",
    pda_rol ="ROL_PROCESSO_TELEMATICO"
}